import React, { useState, useEffect, useRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { throttle } from 'lodash-es';
import SimpleFormat from '@16g/react-simple-format';

const desktopHeight = 100;
const mobileHeight = 280;
const mobileBreakpoint = 960;

const Description = ({ text }) => {
  const descriptionRef = useRef();
  const [open, setOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [initialHeight, setInitialHeight] = useState(desktopHeight);

  useEffect(() => {
    const handleResize = throttle(() => {
      const height = window.innerWidth >= mobileBreakpoint ? desktopHeight : mobileHeight;

      if (descriptionRef.current) {
        setHasMore(descriptionRef.current.scrollHeight > height);
      }

      setInitialHeight(height);
    }, 250);

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const descriptionHeight = () => {
    if (open && descriptionRef.current) {
      return descriptionRef.current.scrollHeight;
    }
    return initialHeight;
  };

  const toggleShowMore = () => {
    setOpen((prevState) => !prevState);
  };

  return (
    <div className="widget-container about-page-description">
      <h2 className="widget-title">Description</h2>

      {text && (
        <div
          ref={descriptionRef}
          style={{ height: descriptionHeight() }}
          className={cx('description-text', { 'description-text-open': !hasMore || open })}
        >
          <SimpleFormat text={text} />
        </div>
      )}

      {hasMore && (
        <div className={cx('description-show-more', { 'show-more-open': open })}>
          <button
            onClick={toggleShowMore}
            className="description-show-more-btn btn btn-link btn-sm"
          >
            {open ? 'Show less' : 'Show more'}
            <span className="hicon-angle-down" />
          </button>
        </div>
      )}
    </div>
  );
};

Description.propTypes = {
  text: T.string.isRequired,
};

export default Description;
